import { render } from "./RedesSociais.vue?vue&type=template&id=5900aa53&scoped=true&lang=pug"
import script from "./RedesSociais.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesSociais.vue?vue&type=script&setup=true&lang=js"

import "./RedesSociais.vue?vue&type=style&index=0&id=5900aa53&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5900aa53"]])

export default __exports__